import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';

/**
 * @param {string} stringValue
 * @returns {number}
 */
const parseTimeString = (stringValue, maxHoursDigits = 2) => {
    stringValue = stringValue.replace(/[^\d:]/g, '');
    const split = stringValue.includes(':') ? stringValue.split(':') : `${stringValue}:`.split(':');
    const hours = Number(split[0].substring(0, maxHoursDigits));
    const parsedMinutes = Number(split[1].substring(0, 2));
    const roundedMinutes = Math.ceil(parsedMinutes / 15) * 15;
    const minutes = roundedMinutes >= 60 ? 0 : roundedMinutes;
    return hours + minutes / 60.0;
};

/**
 * @param {number} num
 */
const setTwoDigits = (num) => `0${Math.floor(num)}`.slice(-2);

const padDigits = (num, digits) => `${'0'.repeat(digits)}${Math.floor(num)}`.slice(-digits);

/**
 * @param {number} value
 * @param {number} [hoursDigits]
 * @returns {string}
 */
const getTimeString = (value, hoursDigits = 2) => {
    const hours = padDigits(value, hoursDigits);
    const minutes = setTwoDigits((value * 60) % 60);
    return `${hours}:${minutes}`;
};

const DurationInput = ({ onChange, value, maxHoursDigits = 2, ...others }) => {
    const [displayedValue, setDisplayedValue] = useState(others.placeholder && (value === null || value === 0) ? "" : getTimeString(value, maxHoursDigits));
    const changeOnBlur = (ev, updatedValue) => {
        const parsedValue = parseTimeString(ev.target.value, maxHoursDigits);
        onChange(parsedValue, updatedValue);
        setDisplayedValue(getTimeString(parsedValue, maxHoursDigits));
    };

    useEffect(() => {
        setDisplayedValue(others.placeholder && (value === null || value === 0) ? "" : getTimeString(value, maxHoursDigits));
    }, [value]);

    return (
        <TextField
            size={others.size ?? "medium"}
            onChange={(ev) => setDisplayedValue(ev.target.value)}
            onBlur={changeOnBlur}
            value={displayedValue}
            {...others}
        />
    );
};

export default DurationInput;
